/**
 * Configuração centralizada de autenticação do B2B.
 * Token e dados do usuário são persistidos no localStorage.
 */
import { createPersistentAuthStorage } from '@e-learning/core';

export const AUTH_DATA_KEY = 'e-learning-b2b-auth-data';

export const authStorage = createPersistentAuthStorage(AUTH_DATA_KEY);
